import template from './fees.html';
const Fees = {
    bindings: {
        fees: '<',
    },
    template,
};
export default Fees;



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/funds/components/fees/fees.ts